<template>
  <q-page padding>
    <div class="relative-position loader">
      <registration-link></registration-link>
    </div>
  </q-page>
</template>

<script>
import RegistrationLink from '../../../components/company/registrationLink'

export default {
  components: { RegistrationLink },
  data: () => ({}),
  async created () {},
  computed: {},
  methods: {}
}
</script>
